import { render, staticRenderFns } from "./Parallax.vue?vue&type=template&id=08999a03&scoped=true&"
import script from "./Parallax.vue?vue&type=script&lang=js&"
export * from "./Parallax.vue?vue&type=script&lang=js&"
import style0 from "./Parallax.vue?vue&type=style&index=0&id=08999a03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08999a03",
  null
  
)

export default component.exports